<template>
  <!-- Loading -->
  <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Name
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0">
            {{ contractfile.name }}
          </dd>
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            File
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0">
            {{ contractfile.file }}
          </dd>
        </div>
        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:px-6">
          <div class="form-modal" style="width: 100% !important;" v-if="contractfile.type == 'pdf'">
            <div v-if="contractfile.base64 != ''">
              <vue-pdf-embed :source="contractfile.base64" />
            </div>
          </div>
          <img class="image pl-4 mt-2" :src="contractfile.base64" :alt="contractfile.type" v-else>
        </div>
      </dl>
    </div>
  </div>

</template>
<script>
/* eslint-disable */
import { ref, watch, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import Loading from 'vue-loading-overlay'
import VuePdfEmbed from 'vue-pdf-embed'
export default {
  name: 'ClassForm',
  components: {
    Loading,
    VuePdfEmbed
  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])
    const isLoading = ref(false)

    const contractfile = ref({})
    watchEffect(() => {
      contractfile.value = props.propObject
    })

    return {
      isLoading,
      titleStack,
      contractfile,
    }
  }
}
</script>